<template>
  <q-card
    class="column bg-transparent"
    flat
  >
    <q-card-section
      v-if="showHeader"
      class="text-h5 text-left bg-primary q-px-md q-py-sm rounded-borders-8 q-mb-sm"
      :class="$getTextColor(currentSite, 'primary')"
    >
      {{ item.name }}
    </q-card-section>
    <q-card-section
      class="row q-pa-none"
    >
      <q-list
        class="full-width"
      >
        <q-item
          v-for="itemVariation in item.itemVariations.data"
          :key="itemVariation.id"
          class="row q-px-md q-py-sm rounded-borders-8 borders q-mb-sm items-center"
          :class="{ 'justify-between': $q.screen.lt.sm }"
          :style="{ 'flex-wrap': $q.screen.lt.sm ? 'wrap' : undefined }"
        >
          <q-item-section
            :class="{
              'col-12': $q.screen.lt.sm,
              'col': !$q.screen.lt.sm
            }"
          >
            <div
              class="text-subtitle2"
              style="font-size: 1rem; line-height: 1.5;"
            >
              {{ itemVariation.name }}
            </div>
            <div
              v-if="itemVariation.description"
              class="text-caption"
              style="line-height: 1;"
            >
              {{ itemVariation.description }}
            </div>
          </q-item-section>
          <q-item-section
            class="col-auto"
            :class="{ 'q-px-md': !$q.screen.lt.sm }"
            :style="{ 'margin-left': $q.screen.lt.sm ? '0' : undefined }"
          >
            <i18n-n
              class="text-subtitle1"
              tag="span"
              :value="itemVariation.price"
              format="currency"
              scope="global"
            />
          </q-item-section>
          <q-item-section class="col-auto">
            <add-and-remove-button-set
              :show-add-button="$_.isNil(activityBooking.salesItemCount(itemVariation)) || activityBooking.salesItemCount(itemVariation) < 1"
              :quantity="activityBooking.salesItemCount(itemVariation)"
              :item-count-description="activityBooking.salesItemCount(itemVariation)"
              :decrement-disabled="activityBooking.salesItemCount(itemVariation) < 1"
              :square="$register"
              :outline="$register"
              :rounded="!$register"
              @add="activityBooking.incrementSalesItem(itemVariation)"
              @decrement="decrementSalesItem(itemVariation)"
              @increment="activityBooking.incrementSalesItem(itemVariation)"
            />
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
  </q-card>
</template>

<script>
import { useRemoveOrderItem } from 'src/composables/order/order-items/RemoveOrderItem'
import ActivityBooking from 'src/models/activity/ActivityBooking'
import Item from 'src/models/item/Item'
import { ORDER_ITEM_STATES } from 'src/models/order-item/OrderItem'
import AddAndRemoveButtonSet from 'src/modules/checkout/components/AddAndRemoveButtonSet.vue'
export default {
  name: 'ActivitySalesItemCard',
  components: { AddAndRemoveButtonSet },
  configuration: ['currentSite'],
  inject: ['order'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    },
    item: {
      type: Item,
      required: true
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup () {
    const { removeOrderItem } = useRemoveOrderItem()
    return {
      removeOrderItem
    }
  },
  methods: {
    decrementSalesItem (itemVariation) {
      const lastAddedOrderItem = _.findLast(this.order.draftOrderItems, orderItem => {
        if (orderItem.state !== ORDER_ITEM_STATES.DRAFT) return false
        if (!_.isNil(orderItem.itemPackageId)) return false
        if (orderItem.itemOrderItem?.itemVariationId !== itemVariation.id) return false
        // activityBookingId is on the orderItem, not on itemOrderItem
        if (orderItem.activityBookingId !== this.activityBooking.id) return false

        return true
      })

      if (!_.isNil(lastAddedOrderItem)) {
        this.removeOrderItem(lastAddedOrderItem)
      }
    }
  }
}
</script>
